import React from "react";
import PropTypes from "prop-types";
import { Image } from "@lululemon/ui-library";

/**
 * This is just a wrapper around the Image component from '@lululemon/ecom-pattern-library'
 * All it provides is an error fallback when an image fails to load. All other props
 * and behavior remains the same.
 */
const ImageWithFallback = React.forwardRef(
  ({ alt, className, mobileSrc, src, fallbackElement, ...rest }, ref) => {
    const [hasError, setError] = React.useState(false);

    return hasError ? (
      fallbackElement
    ) : (
      <Image
        alt={alt}
        className={className}
        src={src}
        mobileSrc={mobileSrc}
        onError={() => setError(true)}
        {...rest}
        ref={ref}
      />
    );
  }
);

ImageWithFallback.defaultProps = {
  alt: "",
  className: "",
  mobileSrc: null
};

ImageWithFallback.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  mobileSrc: PropTypes.string,
  src: PropTypes.string.isRequired
};

ImageWithFallback.displayName = "ImageWithFallback";

export default ImageWithFallback;
